module.exports = __webpack_public_path__ + "static/media/communications-landscape.81aa87af.jpg";